import React, { useMemo } from "react";

import DataTable from "../../common/components/ReactTable";

import columns from "./models/activity-list.columns";

import { MarketingActivity as Activity } from "../../api";

interface MarketingActivitiesListProps {
  activities?: Activity[];
  isLoading: boolean;
  handleSelect: (id: string) => any;
}

const MarketingActivitiesList: React.FC<MarketingActivitiesListProps> = ({
  activities,
  isLoading,
  handleSelect,
}) => {

  const items = useMemo(
    () => activities || [],
    [activities]);

  return (
    <DataTable
      columns={columns}
      data={items}
      onSelect={item => handleSelect(item.id)}
      messages={{
        noRecords: "No activities found",
        noMatches: "No matching activities found"
      }}
      isLoading={isLoading}
    />
  );
};

export default MarketingActivitiesList;
